export const extractBaseCaneCode = (caneCode: string): string => {
  if (!caneCode) {
    return '';
  }
  const trailingLetters = caneCode.match(/[A-Z]+$/);
  if (trailingLetters) {
    return caneCode.slice(0, -trailingLetters[0].length);
  }
  return caneCode;
};

export const generateNextCaneCode = (
  baseCane: string,
  existingCodes: string[],
): string => {
  if (!baseCane) {
    return '';
  }

  const base = extractBaseCaneCode(baseCane);

  const allCodes = [baseCane, ...existingCodes].filter((code) =>
    code.startsWith(base),
  );

  const suffixes = allCodes
    .map((code) => code.substring(base.length))
    .filter((suffix) => /^[A-Z]*$/.test(suffix))
    .map((s) => s || '')
    .sort((a, b) => {
      if (a.length !== b.length) {
        return a.length - b.length;
      }
      return a.localeCompare(b);
    });

  if (suffixes.length === 0 || suffixes[suffixes.length - 1] === '') {
    return `${base}A`;
  }

  const lastSuffix = suffixes[suffixes.length - 1];
  const lastChar = lastSuffix[lastSuffix.length - 1];
  const nextCharCode = lastChar.charCodeAt(0) + 1;

  if (nextCharCode > 90) {
    if (lastSuffix === 'Z') {
      return `${base}AA`;
    }
    const prefix = lastSuffix.slice(0, -1);
    return `${base}${prefix}AA`;
  }

  return `${base}${lastSuffix.slice(0, -1)}${String.fromCharCode(nextCharCode)}`;
};

export const validateCaneCodeUniqueness = (
  code: string,
  allCodes: string[],
  currentIndex: number,
): boolean => {
  const otherCodes = allCodes.filter((_, index) => index !== currentIndex);
  return !otherCodes.includes(code);
};
